import OnboardingJourney from "@/components/marketing/OnboardingJourney";
import Seo from "@/components/marketing/Seo";
import PublicSiteLayout from "@/components/layouts/PublicSiteLayout";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const IntroAddJob = () => {
  return (
    <PublicSiteLayout>
      <Seo
        title="Add a Job with HiredCoach | Aim Your Prep at a Real Opportunity"
        description="Preview the HiredCoach onboarding step that guides users from resume setup into adding a real job listing for tailored coaching."
        canonicalPath="/intro/add-job"
      />

      <section className="bg-gradient-to-b from-[#fff9f0] to-white py-20">
        <div className="container mx-auto px-6">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-amber-700">Intro Preview</p>
            <h1 className="mt-4 text-4xl font-bold text-slate-900 md:text-5xl">
              Next stop: aim at a real role
            </h1>
            <p className="mt-6 text-lg leading-8 text-slate-600">
              Once the resume is in place, the next move is adding a target job so practice and analysis match a live opportunity.
            </p>
          </div>

          <div className="mt-14">
            <OnboardingJourney activeStage="job" />
          </div>

          <div className="mx-auto mt-10 max-w-2xl rounded-3xl border border-amber-100 bg-amber-50 p-8 text-center">
            <h2 className="text-2xl font-bold text-slate-900">Why this matters</h2>
            <p className="mt-4 text-slate-600">
              The job listing gives HiredCoach the role, level, and language needed to produce sharper prep and more credible feedback.
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
              <Button asChild className="rounded-full bg-sky-600 px-8 hover:bg-sky-500">
                <Link to="/register">
                  Start With HiredCoach
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" className="rounded-full px-8">
                <Link to="/how-it-works">Back to How It Works</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </PublicSiteLayout>
  );
};

export default IntroAddJob;
